import { styled } from '@mui/material/styles';

export const StyledContentContainer = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 24px;

  .toolbar-container {
    display: flex;
    flex-direction: column;
  }

  .toolbar-container-tabs {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .loading-container {
    display: flex;
    justify-content: center;
  }
`;
